export default class GetPerfilCursoByAnioCursoAndId {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idAnioCurso, idPerfilCurso) {
    try {
      const result = await this.#repository.getPerfilCursoByAnioCursoAndId(idAnioCurso, idPerfilCurso)
      return result
    } catch (error) {
      throw error
    }
  }
}
